import { configureStore, createSlice } from '@reduxjs/toolkit';

// Purchases slice to track purchased products and courses
const purchasesSlice = createSlice({
  name: 'purchases',
  initialState: {
    purchasedProducts: JSON.parse(localStorage.getItem('purchasedProducts') || '[]'),
    purchasedCourses: JSON.parse(localStorage.getItem('purchasedCourses') || '[]'),
    isLoading: false,
    error: null
  },
  reducers: {
    addPurchasedProduct: (state, action) => {
      const productId = action.payload;
      if (!state.purchasedProducts.includes(productId)) {
        state.purchasedProducts.push(productId);
        localStorage.setItem('purchasedProducts', JSON.stringify(state.purchasedProducts));
      }
    },
    addPurchasedCourse: (state, action) => {
      const courseId = action.payload;
      if (!state.purchasedCourses.includes(courseId)) {
        state.purchasedCourses.push(courseId);
        localStorage.setItem('purchasedCourses', JSON.stringify(state.purchasedCourses));
      }
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const { addPurchasedProduct, addPurchasedCourse, setLoading, setError, clearError } = purchasesSlice.actions;

export const store = configureStore({
  reducer: {
    purchases: purchasesSlice.reducer,
  },
});

// Selectors
export const selectPurchasedProducts = (state) => state.purchases.purchasedProducts;
export const selectPurchasedCourses = (state) => state.purchases.purchasedCourses;
export const selectIsProductPurchased = (state, productId) => 
  state.purchases.purchasedProducts.includes(productId);
export const selectIsCoursePurchased = (state, courseId) => 
  state.purchases.purchasedCourses.includes(courseId);
export const selectIsLoading = (state) => state.purchases.isLoading;
export const selectError = (state) => state.purchases.error; 